var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cardData && _vm.cardData.length > 0
    ? _c("div", { staticClass: "ovy-auto" }, [
        _c(
          "ul",
          _vm._l(_vm.cardData, function(ticket) {
            return _c("li", { key: ticket.id, staticClass: "ticket" }, [
              _c(
                "a",
                {
                  staticClass: "gray-100 p-2 br",
                  attrs: { href: "/?_f=support_ticket&tid=" + ticket.id }
                },
                [
                  _c("p", { staticClass: "fs-2 status my-1" }, [
                    _c("span", {
                      staticClass: "chip",
                      class: _vm.checkChip(ticket.step)
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$filters.capitalize(_vm.checkStatus(ticket.step))
                        ) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(ticket.subject))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "fs-2 gray-60 my-1" }, [
                    _c("span", { staticClass: "mr-3" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.dateFormatter(
                            ticket.updatedDate,
                            "SLASHED_DATE_TIME"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "mr-3" }, [
                      _vm._v("#" + _vm._s(ticket.ident))
                    ]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(ticket.thirdname))])
                  ]),
                  _vm._v(" "),
                  _vm.context == "ticket_corp"
                    ? _c("div", { staticClass: "fs-2 gray-60 my-1" }, [
                        ticket.assigned
                          ? _c("p", [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$l10n.__("Assigné à : %(staffname)s", {
                                      staffname: ticket.assigned
                                    })
                                  ) +
                                  "\n                    "
                              )
                            ])
                          : _c("p", [
                              _vm._v(_vm._s(_vm.$l10n.__("Non assigné")))
                            ])
                      ])
                    : _vm._e()
                ]
              )
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "link acenter dd mt-4",
            attrs: { href: _vm.filterUrl(_vm.context) }
          },
          [_vm._v(_vm._s(_vm.$l10n.__("Voir tous les tickets")))]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }